import TCS_LOGO from "../../../assets/icon/company_logo.png"
import CAMERA_ICON_PNG from "../../../assets/icon/cameraIcon.png"
import SATTVA_LOGO from "../../../assets/icon/sattva_logo.png"
import { getClientSource } from "./Functions"

const source = getClientSource()
export const image = {
    LOGO: source === "tcs" ? TCS_LOGO : SATTVA_LOGO,
    CAMERA_ICON: CAMERA_ICON_PNG
}